import type { ReactNode } from "react";

import { PageColumns } from "../../ui/PageColumns";
import classes from "./SettingsFrame.module.css";
import { SettingsTabs } from "./SettingsTabs";

/**
 * Settings' page frame (design-system.md 3.7): the pill tabs as links over a body at most 1400px
 * wide. The members and the tokens routes both render inside it, so the URL stays the one state.
 */
export function SettingsFrame({ teamId, children }: { teamId: string; children: ReactNode }) {
  return (
    <PageColumns top={<SettingsTabs teamId={teamId} />}>
      <div className={classes.body}>{children}</div>
    </PageColumns>
  );
}
